"use client"
import { useEffect } from "react"
export default function ClientCacheFix() {
  useEffect(() => {
    const onPageShow = (e: any) => { if (e?.persisted) window.location.reload() }
    window.addEventListener("pageshow", onPageShow)
    return () => window.removeEventListener("pageshow", onPageShow)
  }, [])
  return null
}